export const sheetVariants = (prefersReduced) => prefersReduced
  ? {
      hidden:  { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.15 } },
      exit:    { opacity: 0, transition: { duration: 0.1 } },
    }
  : {
      hidden:  { y: '100%' },
      visible: { y: 0,      transition: { duration: 0.4, ease: [0.0, 0.0, 0.2, 1] } },
      exit:    { y: '100%', transition: { duration: 0.3, ease: [0.4, 0.0, 1, 1] } },
    }

export const containerVariants = (prefersReduced) => prefersReduced
  ? { hidden: { opacity: 1 }, visible: { opacity: 1 } }
  : {
      hidden:  {},
      visible: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
    }

export const itemVariants = {
  hidden:  { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
}

export const imageVariants = {
  hidden:  { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
}
